import React, { useEffect, useState } from 'react'
import { Container, Row, Col } from 'reactstrap'
import { ForgotPassword } from '../../components/ForgotPassword/ForgotPassword';
import { NavigationBar } from '../../components/NavigationBar/NavigationBar'
import { APP_VERSION, getTenantByKey, getUserDataByKey, setColor } from '../../helpers/helpers';
import { Footer } from '@exactian/exactian-components';

export const Main = ({ children }) => {

    const [modal, setModal] = useState(false);

    const minHeight = {
        minHeight: '85vh',
    };

    const userName = getUserDataByKey('first_name');
    const year = getTenantByKey('year');

    useEffect(() => {
        setColor(getTenantByKey('theme'));
        document.title = getTenantByKey('app_name');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Container className="themed-container d-flex flex-column min-vh-100 p-0 h-100" fluid={true}>
            <ForgotPassword modal={modal} setModal={setModal} />
            <NavigationBar name={userName} setModal={setModal} />
            <Row className="flex-grow-1 p-0 m-0 d-flex justify-content-center align-content-start">
                <Col style={minHeight}>{children}</Col>
            </Row>
            <Footer
                appVersion={APP_VERSION}
                year={year}
                showPrivacyPolicy={false}
            />
        </Container>
    )
}
